<script setup lang="ts">
import { ref, watch } from "vue";
import MCQBlock from "~/features/python/ch2/exercise/components/MCQBlock.vue";
import CodeQuestion from "~/features/python/ch2/exercise/components/CodeQuestion.vue";
import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

const props = defineProps<{
  question: Question;
}>();

const emit = defineEmits<{
  (event: "submitted", value: number | string): void;
}>();

const writtenAnswer = ref("");

watch(
  () => props.question.id,
  () => {
    writtenAnswer.value = "";
  },
);

function submitWrittenAnswer() {
  if (!writtenAnswer.value.trim()) {
    return;
  }

  emit("submitted", writtenAnswer.value.trim());
}
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Pehle khud karo</h2>
      <p class="text-sm text-slate-600">Sab se pehle apna answer do. Phir hum sahi jawab dikhayenge.</p>
    </div>

    <div class="mt-5">
      <MCQBlock
        v-if="question.type === 'mcq'"
        :question="question"
        @submitted="emit('submitted', $event)"
      />

      <CodeQuestion
        v-else-if="question.type === 'code'"
        :question="question"
        @submitted="emit('submitted', $event)"
      />

      <div v-else class="space-y-4">
        <p class="rounded-2xl bg-slate-50 p-4 text-sm text-slate-700 ring-1 ring-slate-200">
          Apna jawab likho. Button dabane ke baad hum sahi jawab aur asaan steps dikhayenge.
        </p>
        <textarea
          v-model="writtenAnswer"
          rows="5"
          class="w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm text-slate-900 outline-none focus:border-sky-400"
          placeholder="Yahan apna answer likho"
        />
        <button
          type="button"
          class="rounded-full bg-slate-950 px-4 py-2 text-sm font-medium text-white"
          :disabled="!writtenAnswer.trim()"
          @click="submitWrittenAnswer"
        >
          Mera answer check karo
        </button>
      </div>
    </div>
  </section>
</template>
